import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import "./registerServiceWorker";
import "./plugins/element.js";
import GlobalPlugins from "./plugins/globalPlugins.js";
// 导入公共组件
import "./components/common/index";
import '../src/assets/style/index.less';
import '../src/assets/style/index.scss'

Vue.config.productionTip = false;

import Affix from "vue-affix";
Vue.use(Affix);
Vue.use(GlobalPlugins);
const APP = new Vue({
  router,
  store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
});
APP.$store.dispatch("getInitDate").then(res => {
  if (res) {
    APP.$mount("#app");
    // console.log(res[0]);
    // if(res[0] == 99010){
    //   APP.$router.push('/index')
    // }
  }
});
